import React, { useState } from 'react';
import { Formik, FormikHelpers } from 'formik';
import * as Yup from 'yup';
import { ISchool } from './models';
import { SchoolApi } from 'api/schoolApi';
import { PopupOrPanel } from '../../components/popupsAndPanels/PopupAndPanels';
import { UpdateSchoolForm } from './UpdateSchoolForm';

const validationSchemaUpdateSchool = Yup.object({
  schoolName: Yup.string().required('A school name is required').nullable(),
  schoolPhoneNumber: Yup.string().required('A school phone number is required').nullable(),
  addressLine1: Yup.string().required('An address is required').nullable(),
  addressLine2: Yup.string().nullable(),
  addressLine3: Yup.string().nullable(),
  townCity: Yup.string().required('A town or city is required').nullable(),
  postcodeZipcode: Yup.string().required('A postcode is required').nullable(),
  county: Yup.string().nullable(),
  country: Yup.string().required('A country is required').nullable(),
  financeEmail: Yup.string().email('Please enter a valid email').required('A finance email is required').nullable(),
});

type Props = {
  panelOpen: boolean;
  togglePanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  schoolDetails: ISchool | null;
  setSchoolDetails: React.Dispatch<React.SetStateAction<ISchool | null>>;
};

export const UpdateSchool: React.FC<Props> = ({
  panelOpen,
  togglePanelOpen,
  schoolDetails,
  setSchoolDetails,
}) => {
  const [error, setError] = useState<string>('');
  const [schoolLogoUrl, setSchoolLogoUrl] = useState<any>(schoolDetails && schoolDetails.logoUrl && schoolDetails.logoExtension ? schoolDetails.logoUrl : null);  
  const [schoolLogoFile, setSchoolLogoFile] = useState<any>(null);
  const [schoolLogoUpdated, setSchoolLogoUpdated] = useState<boolean>(false); 
  const [schoolLogoExt, setSchoolLogoExt] = useState<any>(schoolDetails && schoolDetails.logoUrl && schoolDetails.logoExtension ? schoolDetails.logoExtension : null); 
  const [removeSchoolLogo, setRemoveSchoolLogo] = useState<boolean>(false);    

  const handleSubmitUpdateSchool = async (
    values: any,
    { setSubmitting }: FormikHelpers<ISchool>
  ) => {
    const formData = new FormData();
    let valuesObj: any = Object.keys(values).map((key: any) => [key, values[key]]);
    valuesObj = valuesObj.filter((item: any) => item[0] !== "logoExtension");
    valuesObj.map((item: any) => formData.append(item[0], item[1]));

    formData.append("Logo", schoolLogoUpdated ? schoolLogoFile : null);
    formData.append("logoExtension", schoolLogoExt === null ? "" : schoolLogoExt);
    formData.append("bDeleteLogo", removeSchoolLogo ? "true" : "false");

    setSubmitting(true);
    const result = await SchoolApi.submitSchoolDetailsIForm(formData);
    if (result.data) {
      setSchoolDetails(result.data);
      setSubmitting(false);
      togglePanelOpen(false);
    }

    if (result.error) {
      const error = result.error.message;
      setError(error);
      setSubmitting(false);
    }
  };

  return (
    <React.Fragment>
      {schoolDetails && (
        <Formik
          initialValues={schoolDetails}
          onSubmit={(values, formikHelpers) =>
            handleSubmitUpdateSchool(values, formikHelpers)
          }
          validationSchema={validationSchemaUpdateSchool}
          validateOnBlur={false}
        >
          {({ submitForm, isSubmitting }) => (
            <PopupOrPanel
              isPopup={false}
              isOpen={panelOpen}
              isSubmitting={isSubmitting}
              position="right"
              hdrTitle="Update school"
              primaryBtnTxt="Save"
              secondaryBtnTxt="Cancel"
              givenClass="ManageSchoolPopoutMenu"
              handleClose={() => togglePanelOpen(false)}
              handlePrimaryBtn={submitForm}
              handleSecondaryBtn={() => togglePanelOpen(false)}
              width={560}
            >
              <UpdateSchoolForm 
                schoolDetails={schoolDetails}
                schoolLogoFile={schoolLogoFile}
                setSchoolLogoFile={setSchoolLogoFile}
                schoolLogoUrl={schoolLogoUrl}
                setSchoolLogoUrl={setSchoolLogoUrl}
                schoolLogoExt={schoolLogoExt}
                removeSchoolLogo={removeSchoolLogo}
                setRemoveSchoolLogo={setRemoveSchoolLogo}
                setSchoolLogoUpdated={setSchoolLogoUpdated}
              />
            </PopupOrPanel>
          )}
        </Formik>
      )}
    </React.Fragment>
  );
};
